/**
 * Picks v2 or v1 of the Authors page based on the redesign flag.
 * Same pattern as the other page switches.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import AuthorsPage   from './AuthorsPage';
import AuthorsPageV2 from './AuthorsPageV2';

export default function AuthorsPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AuthorsPageV2 : AuthorsPage;
  return <Component {...props} />;
}
